module Elma.Bindings {

    export interface IClickChangeTextArgs {

        text: string,

        observable: KnockoutObservable<string>

    }

    export class ClickChangeText {

        public init(element: any, valueAccessor: () => IClickChangeTextArgs, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {

            if (!bindingContext)

                return;

            var value = valueAccessor();



            ko.utils.registerEventHandler(element, "click", function () {

                value.observable(value.text);

            });

        }

    }

    ko.bindingHandlers['clickChangeText'] = new ClickChangeText();

}